/**
 * Fields allowed for direct "Salvează în listă" (no product-code / price impact):
 * - Detalii produs
 * - Structură: sistem / subsistem (+ chapter/subchapter display names refreshed with systems)
 */
export const PRODUCT_DETAILS_KEYS = [
    'productName',
    'measurementUnit',
    'weight',
    'nomenclatureCode',
    'productNotes',
    'isCompositeProduct',
    'componentProductCodes',
    'componentProductsKeepInList',
    'visibleInOfferApp',
    'status',
    'systems',
    'systemSubcategories',
    // Side-effect of primary-system change; codes stay unchanged.
    'chapterName',
    'subchapterName',
];

const PRODUCT_DETAILS_KEY_SET = new Set(PRODUCT_DETAILS_KEYS);

/**
 * @param {string} fieldKey
 * @returns {boolean}
 */
export function isProductDetailsDirectSaveField(fieldKey) {
    return PRODUCT_DETAILS_KEY_SET.has(String(fieldKey || '').trim());
}

/**
 * Direct list save is allowed only when every changed form key is allowlisted.
 * @param {string[]} changedKeys
 * @returns {boolean}
 */
export function changedKeysAllowDirectListSave(changedKeys = []) {
    const keys = Array.isArray(changedKeys) ? changedKeys : [];
    if (!keys.length) {
        return false;
    }
    return keys.every((key) => isProductDetailsDirectSaveField(key));
}
